<template>
    <div @click="closeMenu" class="cover" :class="{'active' : menu_open}"></div>
</template>
<script>

export default {
    props: [],
    data: function () {
        return {
            menu_open: false
        };
    },
    mounted() {
        this.$eventHub.$on('menuIsOpen', (payload) => {
            if(payload.open) {
                this.menu_open = true;
                return
            }
            this.menu_open = false;
        });
    },
    methods: {
        closeMenu() {
            this.$eventHub.$emit('closeMenu');
        }
    },
    beforeDestroy() {
        this.$eventHub.$off('menuIsOpen');
    }
}
</script>

<style lang="scss" scoped>
    .cover{
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, 0.7);
        opacity:0;
        pointer-events: none;
        transition: all 400ms;
        z-index: 100;

        &.active{
            opacity: 1;
            pointer-events: all;
            transition: all 400ms;
        }

    }
</style>
